__turbopack_context__.v({
  "parent_link": "QttteG_parent_link",
  "parent_link_wrapper": "QttteG_parent_link_wrapper",
  "video_link": "QttteG_video_link",
  "video_meta": "QttteG_video_meta",
  "video_thumbnail": "QttteG_video_thumbnail",
});
